/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BookingStudentName } from './bookingStudentName';
import type { BookingStudentEmail } from './bookingStudentEmail';
import type { BookingStatus } from './bookingStatus';
import type { BookingCancelledAt } from './bookingCancelledAt';
import type { BookingCompletedAt } from './bookingCompletedAt';
import type { BookingReminderSentAt } from './bookingReminderSentAt';
import type { BookingVideoMeetingProvider } from './bookingVideoMeetingProvider';
import type { BookingVideoMeetingJoinUrl } from './bookingVideoMeetingJoinUrl';
import type { BookingRecordingUrl } from './bookingRecordingUrl';
import type { BookingVideoMeetingCalendarEventId } from './bookingVideoMeetingCalendarEventId';
import type { BookingInviteResponseStatus } from './bookingInviteResponseStatus';
import type { BookingInviteResponseAt } from './bookingInviteResponseAt';
import type { ExamAdmission } from './examAdmission';
import type { BookingOralExamJoinState } from './bookingOralExamJoinState';
import type { BookingAttendedMinutes } from './bookingAttendedMinutes';
import type { BookingMeetingStartedAt } from './bookingMeetingStartedAt';
import type { BookingMeetingEndedAt } from './bookingMeetingEndedAt';

/**
 * Booking information
 */
export interface Booking {
  bookingId: string;
  slotId: string;
  taskId: string;
  taskVersion: string;
  moduleId: string;
  courseId: string;
  studentId: string;
  studentName?: BookingStudentName;
  studentEmail?: BookingStudentEmail;
  startTime: string;
  endTime: string;
  lecturerId: string;
  status: BookingStatus;
  cancelledAt?: BookingCancelledAt;
  completedAt?: BookingCompletedAt;
  reminderSentAt?: BookingReminderSentAt;
  videoMeetingProvider?: BookingVideoMeetingProvider;
  videoMeetingJoinUrl?: BookingVideoMeetingJoinUrl;
  recordingConsentGiven?: boolean;
  recordingUrl?: BookingRecordingUrl;
  videoMeetingCalendarEventId?: BookingVideoMeetingCalendarEventId;
  inviteResponseStatus?: BookingInviteResponseStatus;
  inviteResponseAt?: BookingInviteResponseAt;
  examAdmission?: ExamAdmission;
  oralExamJoinState?: BookingOralExamJoinState;
  oralExamAdmitted?: boolean;
  attendedMinutes?: BookingAttendedMinutes;
  meetingStartedAt?: BookingMeetingStartedAt;
  meetingEndedAt?: BookingMeetingEndedAt;
}
